import { render, staticRenderFns } from "./TheDefaultLayout.vue?vue&type=template&id=0e64700d&scoped=true&"
import script from "./TheDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./TheDefaultLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheDefaultLayout.vue?vue&type=style&index=0&id=0e64700d&lang=scss&scoped=true&"
import style1 from "./TheDefaultLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e64700d",
  null
  
)

export default component.exports